module.exports = __webpack_public_path__ + "static/5-e77fb07fa5fd1a086bc4148935b05397.gif";